import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { MenuPlugin } from "@syncfusion/ej2-vue-navigations";
import { enableRipple } from '@syncfusion/ej2-base';

enableRipple(true);
Vue.use(MenuPlugin);

import Comp_TreeView from "./Comp_TreeView.vue";
import Comp_ShowProducts from "./Comp_ShowProducts.vue";
import Comp_AddProduct from "./Comp_AddProduct.vue";
import Comp_DeleteProduct from "./Comp_DeleteProduct.vue";
import Comp_AddSubcat from "./Comp_AddSubcat.vue";
import Comp_ProductDetails from "./Comp_ProductDetails.vue";
import Comp_AlternativeProductDetails from "./Comp_AlternativeProductDetails.vue";
import Comp_DeleteCategory from "./Comp_DeleteCategory.vue";
import Comp_NewRootNode from "./Comp_NewRootNode.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/Home", name: "Home", component: Comp_TreeView },
  { path: "/ShowProducts", name: "ShowProducts", component: Comp_ShowProducts },
  { path: "/ShowProductsofCat", name: "ShowProductsofCat", component: Comp_ShowProducts },
  { path: "/AddProduct", name: "AddProduct", component: Comp_AddProduct },
  { path: "/DeleteProduct", name: "DeleteProduct", component: Comp_DeleteProduct },
  { path: "/DeleteProd", name: "DeleteProd" },
  { path: "/AddSubcat", name: "AddSubcat", component: Comp_AddSubcat },
  { path: "/ProductDetails", name: "ProductDetails", component: Comp_ProductDetails },
  { path: "/AlternativeProductDetails", name: "AlternativeProductDetails", component: Comp_AlternativeProductDetails },
  { path: "/DeleteCategory", name: "DeleteCategory", component: Comp_DeleteCategory },
  { path: "/DeleteCat", name: "DeleteCat" },
  { path: "/CrumbClicked", name: "CrumbClicked" },
  { path: "/NewRootNode", name: "NewRootNode", component: Comp_NewRootNode }
];

const router = new VueRouter({
  routes
});

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js